import { en_CA } from '~/locales/en_ca'
import { en_GB } from '~/locales/en_gb'
import { es_mx } from '~/locales/es_mx'
import { es_us } from '~/locales/es_us'
import { fr_ca } from '~/locales/fr_ca'
import { ko } from '~/locales/ko'
import { ne } from '~/locales/ne'
import { te_IN } from '~/locales/te_in'

import { i18nConfig as i18nInstance } from './i18nInstance'
import { en_us } from './locales/en_us'
import { es } from './locales/es'

const resources = {
  'en-GB': en_GB,
  'en-CA': en_CA,
  'en-US': en_us,
  es: es,
  'es-MX': es_mx,
  'es-US': es_us,
  'fr-CA': fr_ca,
  ko: ko,
  ne: ne,
  te: te_IN,
}

// Registered in the export's initializer: under `sideEffects: false`, the
// bundler skips this module when its export resolves elsewhere (a re-export).
const registerAllLocales = () => {
  Object.entries(resources).forEach(([lng, { translation }]) => {
    i18nInstance.addResourceBundle(lng, 'translation', translation)
  })
  return i18nInstance
}

export const i18nConfig = registerAllLocales()
